var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path, _path2, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplitlearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 32,
    r: 2,
    fill: "#fda22e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 41,
    r: 2,
    fill: "#fda22e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 50,
    r: 2,
    fill: "#fda22e"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 2,
    fill: "#fda22e"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 23,
    r: 2,
    fill: "#fda22e"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 14,
    r: 2,
    fill: "#fda22e"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 5,
    r: 2,
    fill: "#fda22e"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 4,
    fill: "#4bbee5"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 19,
    r: 4,
    fill: "#4bbee5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 32,
    r: 4,
    fill: "#4bbee5"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 45,
    r: 4,
    fill: "#4bbee5"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 19,
    r: 4,
    fill: "#fda22e"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 32,
    r: 4,
    fill: "#fda22e"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 45,
    r: 4,
    fill: "#fda22e"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 58,
    r: 4,
    fill: "#4bbee5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f82f45",
    d: "M37,50L37,50c-1.105,0-2-0.895-2-2V15c0-1.105,0.895-2,2-2h0c1.105,0,2,0.895,2,2v33 C39,49.105,38.105,50,37,50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#161828",
    d: "M42,18c0.265,0,0.52-0.105,0.707-0.293L54.414,6h1.77C56.598,7.161,57.698,8,59,8 c1.654,0,3-1.346,3-3s-1.346-3-3-3c-1.302,0-2.402,0.839-2.816,2H54c-0.265,0-0.52,0.105-0.707,0.293L41.586,16H40v-1 c0-1.654-1.346-3-3-3s-3,1.346-3,3v3h-5.101c-0.465-2.279-2.484-4-4.899-4c-1.252,0-2.384,0.479-3.262,1.242l-9.256-7.068 C11.804,7.513,12,6.782,12,6c0-2.757-2.243-5-5-5S2,3.243,2,6s2.243,5,5,5c1.252,0,2.384-0.479,3.262-1.242l9.256,7.068 c-0.181,0.371-0.332,0.758-0.417,1.173h-7.202C11.434,15.721,9.414,14,7,14c-2.757,0-5,2.243-5,5s2.243,5,5,5 c1.252,0,2.384-0.479,3.262-1.242l3.59,2.742l-3.59,2.742C9.384,27.479,8.252,27,7,27c-2.757,0-5,2.243-5,5s2.243,5,5,5 c1.252,0,2.384-0.479,3.262-1.242l3.59,2.742l-3.59,2.742C9.384,40.479,8.252,40,7,40c-2.757,0-5,2.243-5,5s2.243,5,5,5 c2.414,0,4.434-1.721,4.899-4h7.202c0.085,0.415,0.236,0.802,0.417,1.173l-9.256,7.068C9.384,53.479,8.252,53,7,53 c-2.757,0-5,2.243-5,5s2.243,5,5,5s5-2.243,5-5c0-0.782-0.196-1.513-0.518-2.173l9.256-7.068C21.616,49.521,22.748,50,24,50 c2.414,0,4.434-1.721,4.899-4H34v2c0,1.654,1.346,3,3,3s3-1.346,3-3h1.586l11.707,11.707C53.48,59.895,53.735,60,54,60h2.184 c0.414,1.161,1.514,2,2.816,2c1.654,0,3-1.346,3-3s-1.346-3-3-3c-1.302,0-2.402,0.839-2.816,2h-1.77L42.707,46.293 C42.52,46.105,42.265,46,42,46h-2v-3h4.586l7.707,7.707C52.48,50.895,52.735,51,53,51h3.184c0.414,1.161,1.514,2,2.816,2 c1.654,0,3-1.346,3-3s-1.346-3-3-3c-1.302,0-2.402,0.839-2.816,2h-2.77l-7.707-7.707C45.52,41.105,45.265,41,45,41h-5v-3h8.586 l3.707,3.707C52.48,41.895,52.735,42,53,42h3.184c0.414,1.161,1.514,2,2.816,2c1.654,0,3-1.346,3-3s-1.346-3-3-3 c-1.302,0-2.402,0.839-2.816,2h-2.77l-3.707-3.707C49.52,36.105,49.265,36,49,36h-9v-3h16.184c0.414,1.161,1.514,2,2.816,2 c1.654,0,3-1.346,3-3s-1.346-3-3-3c-1.302,0-2.402,0.839-2.816,2H40v-3h9c0.265,0,0.52-0.105,0.707-0.293L53.414,24h2.77 c0.414,1.161,1.514,2,2.816,2c1.654,0,3-1.346,3-3s-1.346-3-3-3c-1.302,0-2.402,0.839-2.816,2H53c-0.265,0-0.52,0.105-0.707,0.293 L48.586,26H40v-3h5c0.265,0,0.52-0.105,0.707-0.293L53.414,15h2.77c0.414,1.161,1.514,2,2.816,2c1.654,0,3-1.346,3-3s-1.346-3-3-3 c-1.302,0-2.402,0.839-2.816,2H53c-0.265,0-0.52,0.105-0.707,0.293L44.586,21H40v-3H42z M59,4c0.551,0,1,0.448,1,1s-0.449,1-1,1 s-1-0.448-1-1S58.449,4,59,4z M59,58c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1S58.449,58,59,58z M59,49c0.551,0,1,0.448,1,1 s-0.449,1-1,1s-1-0.448-1-1S58.449,49,59,49z M59,40c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1S58.449,40,59,40z M59,31 c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1S58.449,31,59,31z M59,22c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1 S58.449,22,59,22z M59,13c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1S58.449,13,59,13z M28.899,20H34v11h-5.101 c-0.465-2.279-2.484-4-4.899-4c-1.252,0-2.384,0.479-3.262,1.242l-3.59-2.742l3.59-2.742C21.616,23.521,22.748,24,24,24 C26.414,24,28.434,22.279,28.899,20z M21,32c0-1.654,1.346-3,3-3s3,1.346,3,3s-1.346,3-3,3S21,33.654,21,32z M24,16 c1.654,0,3,1.346,3,3s-1.346,3-3,3s-3-1.346-3-3S22.346,16,24,16z M7,9C5.346,9,4,7.654,4,6s1.346-3,3-3s3,1.346,3,3S8.654,9,7,9z M7,22c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S8.654,22,7,22z M11.482,21.173c0.181-0.371,0.332-0.758,0.417-1.173h7.202 c0.085,0.415,0.236,0.802,0.417,1.173L15.5,24.242L11.482,21.173z M19.518,29.827c-0.181,0.371-0.332,0.758-0.417,1.173h-7.202 c-0.085-0.415-0.236-0.802-0.417-1.173l4.018-3.068L19.518,29.827z M7,35c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3 S8.654,35,7,35z M11.482,34.173c0.181-0.371,0.332-0.758,0.417-1.173h7.202c0.085,0.415,0.236,0.802,0.417,1.173L15.5,37.242 L11.482,34.173z M19.101,44h-7.202c-0.085-0.415-0.236-0.802-0.417-1.173l4.018-3.068l4.018,3.068 C19.337,43.198,19.186,43.585,19.101,44z M7,48c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S8.654,48,7,48z M7,61 c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S8.654,61,7,61z M24,48c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3 S25.654,48,24,48z M28.899,44c-0.465-2.279-2.484-4-4.899-4c-1.252,0-2.384,0.479-3.262,1.242l-3.59-2.742l3.59-2.742 C21.616,36.521,22.748,37,24,37c2.414,0,4.434-1.721,4.899-4H34v11H28.899z M38,48c0,0.552-0.449,1-1,1s-1-0.448-1-1V15 c0-0.552,0.449-1,1-1s1,0.448,1,1V48z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 30,
    y: 23,
    fill: "#161828"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 30,
    y: 27,
    fill: "#161828"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 30,
    y: 35,
    fill: "#161828"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 30,
    y: 39,
    fill: "#161828"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitlearning);
export default __webpack_public_path__ + "static/media/splitlearning.b378048b.svg";
export { ForwardRef as ReactComponent };